module.exports = __webpack_public_path__ + "img/titleA.03028aeb.png";